<div class="flex items-center gap-2 cursor-pointer" data-what="toggle" [attr.data-which]="meta.key">
  <button
    type="button"
    role="switch"
    class="relative flex h-8 w-16 shrink-0 items-center rounded-[5px] px-1 transition-colors"
    [class.bg-hrp-primary-300]="control.value"
    [class.bg-hrp-subtle-300]="!control.value"
    [attr.aria-checked]="!!control.value"
    [id]="meta.key"
    data-what="toggle-button"
    [attr.data-which]="meta.key"
    (click)="toggle()"
  >
    <span
      class="block h-6 w-6 rounded-[5px] transition-transform duration-200"
      [class.translate-x-8]="control.value"
      [class.translate-x-0]="!control.value"
      [class.bg-hrp-primary-700]="control.value"
      [class.bg-hrp-subtle-700]="!control.value"
    ></span>
  </button>
  <span class="text-sm font-semibold text-hrp-subtle-900">
    {{ meta.name }}{{ meta.validators?.required ? '*' : '' }}
  </span>
</div>
